/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT License`)
};

const zh_hans1_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT 协议`)
};

const zh_hant1_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT 授權`)
};

const fr_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence MIT`)
};

const de_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT-Lizenz`)
};

const ja_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT ライセンス`)
};

const ko_footer_license = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT 라이선스`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_license = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_license(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_license", locale)
	if (locale === "en") return en_footer_license(inputs)
	if (locale === "zh-Hans") return zh_hans1_footer_license(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_license(inputs)
	if (locale === "fr") return fr_footer_license(inputs)
	if (locale === "de") return de_footer_license(inputs)
	if (locale === "ja") return ja_footer_license(inputs)
	return ko_footer_license(inputs)
};